import React from 'react';
import { Label } from '../atoms/label';
import { Link } from '../atoms/link';
import messageConst from '../../const/messageConst';

export const WeeksDateCrawlFacility = (props) => {
    const {
        data,
        roomData,
        restaurantData,
        titleFacilityName,
        onClick,
        onClickOpenRoomDetailPopup,
        onClickOpenRestaurantVacancyPopup
    } = props;

    const dateCols = data.map((value, index) =>
        <th key={'col1' + index} className={value.color == "black" ? "crawlSearch_tdStyleBlack" : (value.color == "red" ? "crawlSearch_tdStyleRed" : "crawlSearch_tdStyleBlue")}>
            <Label label={value.day} className="crawlSearch_calendarDate" />
            <Label label={value.week} className="crawlSearch_calendarDay" />
        </th>
    );
    const roomCols = roomData?.map((room, index, array) =>
        index == 0 || room.grade != array[index - 1].grade ?
            <>
                <tr key={"grade" + index}>
                    <td className="crawlSearch_facilityNameCol" colSpan={room.vacancyDateList.length + 1}>
                        <Label label={room.grade} className="crawlSearch_gradeLabel" />
                    </td>
                </tr>
                <tr key={room.roomTypeNam + index}>
                    <td className={"crawlSearch_roomNameCol " + (room.roomDetailInfo?.roomTypeGazoList?.length ? "pointerClass" : "")} onClick={room.roomDetailInfo?.roomTypeGazoList?.length ? () => onClickOpenRoomDetailPopup(room.roomDetailInfo) : null}>
                        <div className="crawlSearch_roomNameAndCapacity">
                            <Label label={`${room.roomTypeNam}：${room.roomDetailInfo?.hyojiyoTeiin}名`} className={"crawlSearch_roomNameLabel " + (room.roomDetailInfo?.roomTypeGazoList?.length ? "blueLink" : "")} />
                        </div>
                        {room.roomDetailInfo?.roomPrice ?
                            <Label label={"料金：￥" + room.roomDetailInfo?.roomPrice?.toLocaleString()} className={"crawlSearch_roomPrice"} />
                            :
                            <>
                                <Label label={"メンバー料金：￥" + room.roomDetailInfo?.roomPriceMmb?.toLocaleString()} className={"crawlSearch_roomPrice"} />
                                <Label label={"ゲスト料金：￥" + room.roomDetailInfo?.roomPriceGuest?.toLocaleString()} className={"crawlSearch_roomPrice"} />
                            </>
                        }
                    </td>
                    {room.vacancyDateList?.map((vacancy, vacancyIndex) =>
                        <td key={room.facilityId + index + "_" + vacancyIndex} className={vacancy.kushitsuSu != "×" && vacancy.kushitsuSu != "－" && vacancy.kushitsuSu != "／" ?
                            vacancy?.iroKbn == "gold" ? "crawlSearch_vacancyColGold"
                                : vacancy?.iroKbn == "red" ? "crawlSearch_vacancyColRed"
                                    : vacancy?.iroKbn == "blue" ? "crawlSearch_vacancyColBlue"
                                        : "crawlSearch_vacancyCol"
                            : "crawlSearch_vacancyColGray"}>
                            <Link
                                linkTitle={vacancy.kushitsuSu == "×" || vacancy.kushitsuSu == "－" || vacancy.kushitsuSu == "／" ? "" : vacancy.kushitsuSu}
                                className={
                                    vacancy.kushitsuSu == "×" ? "crawlSearch_cross" :
                                        vacancy.kushitsuSu == "－" ? "crawlSearch_minus" :
                                            vacancy.kushitsuSu == "／" ? "crawlSearch_slash" :
                                                "crawlSearch_vacancyNumLink"
                                }
                                onClick={vacancy.kushitsuSu != "×" && vacancy.kushitsuSu != "－" && vacancy.kushitsuSu != "／" ? () => { onClick(room.facilityId, vacancy.riyoDate, vacancy.kushitsuSu == "0", room.roomType) } : null}
                            />
                        </td>
                    )}
                </tr>
            </>
            :
            <tr key={room.roomTypeNam + index}>
                <td className={"crawlSearch_facilityNameCol " + (room.roomDetailInfo?.roomTypeGazoList?.length ? "pointerClass" : "")} onClick={() => room.roomDetailInfo?.roomTypeGazoList?.length ? onClickOpenRoomDetailPopup(room.roomDetailInfo) : null}>
                    <div className="crawlSearch_roomNameAndCapacity">
                        <Label label={`${room.roomTypeNam}：${room.roomDetailInfo?.hyojiyoTeiin}名`} className={"crawlSearch_roomNameLabel " + (room.roomDetailInfo?.roomTypeGazoList?.length ? "blueLink" : "")} />
                    </div>
                    {room.roomDetailInfo?.roomPrice ?
                        <Label label={"料金：￥" + room.roomDetailInfo?.roomPrice?.toLocaleString()} className={"crawlSearch_roomNameLabel "} />
                        :
                        <>
                            <Label label={"メンバー料金：￥" + room.roomDetailInfo?.roomPriceMmb?.toLocaleString()} className={"crawlSearch_roomPrice"} />
                            <Label label={"ゲスト料金：￥" + room.roomDetailInfo?.roomPriceGuest?.toLocaleString()} className={"crawlSearch_roomPrice"} />
                        </>
                    }
                </td>
                {room.vacancyDateList?.map((vacancy, vacancyIndex) =>
                    <td key={room.facilityId + index + "_" + vacancyIndex} className={vacancy.kushitsuSu != "×" && vacancy.kushitsuSu != "－" && vacancy.kushitsuSu != "／" ?
                        vacancy?.iroKbn == "gold" ? "crawlSearch_vacancyColGold"
                            : vacancy?.iroKbn == "red" ? "crawlSearch_vacancyColRed"
                                : vacancy?.iroKbn == "blue" ? "crawlSearch_vacancyColBlue"
                                    : "crawlSearch_vacancyCol"
                        : "crawlSearch_vacancyColGray"}>
                        <Link
                            linkTitle={vacancy.kushitsuSu == "×" || vacancy.kushitsuSu == "－" || vacancy.kushitsuSu == "／" ? "" : vacancy.kushitsuSu}
                            className={
                                vacancy.kushitsuSu == "×" ? "crawlSearch_cross" :
                                    vacancy.kushitsuSu == "－" ? "crawlSearch_minus" :
                                        vacancy.kushitsuSu == "／" ? "crawlSearch_slash" :
                                            "crawlSearch_vacancyNumLink"
                            }
                            onClick={vacancy.kushitsuSu != "×" && vacancy.kushitsuSu != "－" && vacancy.kushitsuSu != "／" ? () => { onClick(room.facilityId, vacancy.riyoDate, vacancy.kushitsuSu == "0", room.roomType) } : null}
                        />
                    </td>
                )}
            </tr>
    );
    const restaurantCols = restaurantData?.map((restaurant, index, array) =>
        index == 0 || restaurant.jikantai != array[index - 1].jikantai ?
            <>
                <tr key={"jikantai" + index}>
                    <td className="crawlSearch_jikantaiCol" colSpan={restaurant.vacancyDateList.length + 1}>
                        <div className='membershipSearch_restaurantLabelWrapper'>
                            <Label label={`レストラン(${restaurant.jikantai})`} className="crawlSearch_gradeLabel" />
                            <Label label={messageConst.BREAKFAST_VACANCY_MESSAGE} className={restaurant.jikantai == "朝食" ? "crawlSearch_gradeLabelRed" : "hiddenItem"} />
                        </div>
                    </td>
                </tr>
                <tr key={restaurant.restaurantCd + index}>
                    <td className="crawlSearch_roomNameCol">
                        <Label label={restaurant.restaurantName} className="crawlSearch_roomNameLabel" />
                    </td>
                    {restaurant.vacancyDateList?.map((vacancy, vacancyIndex) =>
                        <td key={restaurant.facilityId + index + "_" + vacancyIndex} className={vacancy.kusekiMark != "／" ? "crawlSearch_vacancyCol" : "crawlSearch_vacancyColGray"}>
                            <Link
                                className={
                                    vacancy.kusekiMark == "×" ? "crawlSearch_cross" :
                                        vacancy.kusekiMark == "－" ? "crawlSearch_minus" :
                                            vacancy.kusekiMark == "○" ? "crawlSearch_circle" :
                                                vacancy.kusekiMark == "／" ? "crawlSearch_slash" :
                                                    "crawlSearch_vacancyNumLink"
                                }
                                onClick={() => vacancy.kusekiMark == "○" ? onClickOpenRestaurantVacancyPopup(vacancy.akijikanList, restaurant, vacancy.riyoDate) : null}
                            />
                        </td>
                    )}
                </tr>
            </>
            :
            <tr key={restaurant.restaurantCd + index}>
                <td className="crawlSearch_facilityNameCol">
                    <Label label={restaurant.restaurantName} className="crawlSearch_roomNameLabel" />
                </td>
                {restaurant.vacancyDateList?.map((vacancy, vacancyIndex) =>
                    <td key={restaurant.facilityId + index + "_" + vacancyIndex} className={vacancy.kusekiMark != "／" ? "crawlSearch_vacancyCol" : "crawlSearch_vacancyColGray"}>
                        <Link
                            className={
                                vacancy.kusekiMark == "×" ? "crawlSearch_cross" :
                                    vacancy.kusekiMark == "－" ? "crawlSearch_minus" :
                                        vacancy.kusekiMark == "○" ? "crawlSearch_circle" :
                                            vacancy.kusekiMark == "／" ? "crawlSearch_slash" :
                                                "crawlSearch_vacancyNumLink"
                            }
                            onClick={() => vacancy.kusekiMark == "○" ? onClickOpenRestaurantVacancyPopup(vacancy.akijikanList, restaurant, vacancy.riyoDate) : null}
                        />
                    </td>
                )}
            </tr>
    );

    return (
        roomData ?
            <table className='crawlSearch_calendarTable'>
                <tbody>
                    <tr>
                        <th className='crawlSearch_calendarHeader'>
                            <Label label={titleFacilityName} />
                        </th>
                        {dateCols}
                    </tr>
                    {roomCols}
                </tbody>
            </table>
            :
            restaurantData ?
                <table className='crawlSearch_calendarTable'>
                    <tbody>
                        <tr className='crawlSearch_hiddenHeader'>
                            <th className='crawlSearch_calendarHeader'>
                                <Label label={"レストラン"} />
                            </th>
                            {dateCols}
                        </tr>
                        {restaurantCols}
                    </tbody>
                </table>
                :
                null
    );
}